/******************************** Import Package ************************************/
import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Checkbox,
  ListItemText,
  Chip,
  OutlinedInput,
} from "@mui/material";
import { styled } from "@mui/material/styles";

/******************************** Select Styles ************************************/
const ChipsWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  maxWidth: 400,
  whiteSpace: "initial",
  margin: 2,
}));

/******************************** Select Component ************************************/
export default function SelectValue(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    options,
    defaultValue,
    ...other
  } = props;

  const findSelectedData = (data, selectedItem) =>
    data.title === selectedItem ? data : null;

  return (
    <FormControl
      variant="outlined"
      error={Boolean(error)}
      sx={{ minWidth: 250, maxWidth: 400 }}
      className="multi-select multiple"
    >
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        name={name}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => (
          <ChipsWrapper>
            {selected.map((selectedItem) => {
              const selectedData =
                options.find((data) => findSelectedData(data, selectedItem)) ||
                {};
              return (
                <StyledChip
                  key={selectedData.id || selectedItem}
                  label={selectedData.title || selectedItem}
                />
              );
            })}
          </ChipsWrapper>
        )}
        {...other}
      >
        {options.map((item) => (
          <MenuItem key={item.id} value={item.title} sx={{ whiteSpace: "initial" }}>
            <Checkbox checked={value.indexOf(item.title) > -1} />
            <ListItemText primary={item.title} />
          </MenuItem>
        ))}
      </Select>

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
